module.exports = "/_next/static/images/bg-result-popup-ff4ca3ff.png";